export enum LicenseCode {
  // keep these license with icons first and in this order for license package display sorting
  Email = 'email',
  Sms = 'sms',
  FormsAndPages = 'form',
  Ma = 'ma',
  Integrations = 'integrations',
  OneAPI = 'oneapi',
  Survey = 'survey',
  Website = 'website',
  Event = 'event',
  // remaining licenses
  Core = 'core',
  Domains = 'domains',
  EcomFlows = 'ecom-flows',
  EcomRecom = 'ecom-recom',
  Social = 'social',
  Au = 'au',
  Audience = 'audience',
  Commons = 'commons',
  ProSync = 'prosync',
  Dynamics = 'dynamics',
  Magento = 'magento',
  CampaignPlanner = 'campaign-planner',
  Sleeknote = 'sleeknote',
  Leadfamly = 'leadfamly',
  SplitTest = 'tmp-e-split-test',
  TransactionalEmail = 'email-transactional',
  ThirdPartyIntegrations = 'third-party-integrations',
  Folders = 'folders',
  FileImportScheduling = 'file-import-scheduling',
  TmpHidingTargetsAndTopics = 'tmp-hiding-targets-and-topics',
  Localisation = 'localisation',
  Intercom = 'intercom',
  FolderApiNewStorage = 'folder-api-new-storage',
  EmailEditorSingleRowMove = 'email-editor-single-row-move',
  EmailEditorRowMultiSelect = 'email-editor-row-multi-select',
  MaCounterNode = 'ma-counter-node',
  Rfc5322FromDomainPopup = 'rfc-5322-from-domain-popup',
  Rfc5322FromDomainValidation = 'rfc-5322-from-domain-validation',
}

export enum LicenseCodeDisplayName {
  website = 'Website',
  core = 'Core',
  domaiins = 'Domains',
  integrations = 'Integrations',
  ecomFlows = 'Ecom Flows',
  ecomRecom = 'Ecom Recom',
  email = 'Email',
  sms = 'SMS',
  social = 'Social',
  Au = 'Account & Users',
  audience = 'Audience',
  commons = 'Commons',
  ma = 'MA',
  proSync = 'Pro Sync',
  dynamics = 'Dynamics',
  magento = 'Magento',
  oneapi = 'One API',
  form = 'Forms',
  sleeknote = 'Sleeknote',
  leadfamly = 'Leadfamly',
  event = 'Event',
}
